import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';
import { NavLink } from 'react-router-dom';

import { useTranslator } from '@/hooks/useTranslator';

interface Props {
  readonly title: string;
  readonly link: string;
  readonly icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
}

export const HomeNavCard: React.FC<Props> = (props: Props): React.ReactElement => {
  const { link, title, icon: Icon } = props;

  const tr = useTranslator();

  return (
    <Paper component={NavLink} role="button" to={link} sx={styles.card} elevation={1}>
      <ButtonBase sx={styles.button}>
        <Box sx={styles.iconContainer}>
          <Icon role="img" stroke="currentColor" width={24} height="100%" />
        </Box>
        <Typography variant="h8" color="text.primary">
          {tr(title)}
        </Typography>
      </ButtonBase>
    </Paper>
  );
};

const styles: Record<string, SystemStyleObject> = {
  button: {
    width: '100%',
    height: '100%',
    color: '#82A6E3',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 2.5,
  },
  card: {
    height: 124,
    backgroundColor: 'background.paper',
    overflow: 'hidden',
    flex: 1,
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 48,
    height: 48,
    borderRadius: 6,
    backgroundColor: 'custom.Primary1Background',
    color: 'text.primary',
  },
};
